<template>
    <div>
        <UError
            :clear="{ leadingIcon: 'i-lucide:arrow-left', size: 'xl' }"
            :error="sanitizedError"
        ></UError>
    </div>
</template>

<script setup lang="ts">
import { getErrorMessage } from '~~/layers/base/data/errorMessages'
// getErrorStatusCode composable is auto-imported from base layer

const props = defineProps<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any
}>()

// Check if we should redirect immediately - set before template renders to prevent flash
const statusCode = getErrorStatusCode(props.error)

// Get user-friendly error message based on status code
const userFriendlyMessage = getErrorMessage(statusCode)

// Create sanitized error object with generic messages
const sanitizedError = computed(() => ({
    ...props.error,
    message: userFriendlyMessage.message,
    statusMessage: userFriendlyMessage.title,
}))
</script>
